<div class="w-full">
    <div class="bg-card shadow rounded-2xl p-5 m-4">

        <div class="text-2xl text-center font-medium tracking-tight leading-6 mb-8 truncate">
            Well Barrier Schematic
        </div>


        <div role="tablist" class="tabs tabs-boxed w-2/4 mt-2 mb-4">
            <a role="tab" class="tab" [ngClass]="{'primary-tab-active': router.url.includes('configs')}" (click)="toggle('configs')">
                Configuration
            </a>
            <a role="tab" class="tab" [ngClass]="{'primary-tab-active': router.url.includes('application')}" (click)="toggle('application')">
                Application
            </a>
        </div>

        <router-outlet></router-outlet>
    </div>
</div>